import { flex, darkEffect, breakpoints } from "../styles/utils";

import styled from "styled-components";

export const Container = styled.div`
  ${flex("column")}
  bottom: 1.5rem;
  right: 3rem;
  position: fixed;
  width: 375px;

  @media (max-width: ${breakpoints.tablet}) {
    bottom: 1.5rem;
    right: 1.5rem;
  }
`;

type Props = {
  open?: boolean;
};

export const ButtonContainer = styled.div<Props>`
  ${darkEffect}
  ${flex("row", "center", "center")}
  align-self:end;
  background-color: var(--green-2);
  border-radius: 100px;
  height: 56px;
  width: 56px;
  pointer-events: ${(props) => (props.open ? "none" : "")};
`;
